import { Role } from "stream-chat";
import { combinedRoles } from "./constants";
import { ApplicantType } from "shared/types";
import { ActivityItem } from "./types";
import { capitalize, formatToCurrency } from "shared/utils";

export const getAuthorText = ({
  authorName,
  authorRole
}: {
  authorName?: string;
  authorRole?: Role | ApplicantType;
}) => {
  if (!authorName && !authorRole) return "";

  const readableRole = combinedRoles[authorRole || ""];

  if (authorName && readableRole) return `by ${authorName}, ${readableRole}`;

  return `by ${authorName || readableRole}`;
};

export const getActivityMessage = (item: ActivityItem): string | null => {
  if (typeof item.details !== "object") return null;

  const contact = item.details?.contact;
  const nameEmail = contact
    ? `${contact.first_name} ${contact.last_name} ${contact.email ? `(${contact.email})` : ""}`
    : "";

  switch (item.activity_type) {
    case "canadian_criminal_report_invited":
      return `${nameEmail} was emailed a Canadian criminal background check link`;
    case "decision_email_sent":
      return `${nameEmail} was emailed a decision letter`;
    case "credit_report_sent":
      return `${nameEmail} was emailed a credit report`;
    case "placed_on_hold":
    case "resumed":
      return [
        `by ${item.author?.name || "Boom Admin"}`,
        item.author?.author_role
          ? `(${capitalize(
              item.author.author_role.toLowerCase().replace("_", " ")
            )})`
          : ""
      ].join(" ");
    case "submitted":
      if (item.details?.application_fee)
        return `Application fee paid: ${formatToCurrency(
          item.details.application_fee
        )}`;
      return null;
    default:
      return null;
  }
};
